import { render, staticRenderFns } from "./expiration.vue?vue&type=template&id=3b5a200c&scoped=true"
import script from "./expiration.vue?vue&type=script&lang=js"
export * from "./expiration.vue?vue&type=script&lang=js"
import style0 from "./expiration.vue?vue&type=style&index=0&id=3b5a200c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5a200c",
  null
  
)

export default component.exports